import { useEffect, useState } from "react";
import { Loader2, Film } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { FollowBar } from "@/components/SocialFeeds";
import { api } from "@/lib/api";
import { VideoPlayer } from "@/components/VideoPlayer";
import { IMG } from "@/lib/catalog";
import { PhotoGallery } from "@/components/gallery/PhotoGallery";

export const VideoPage = ({ category, seoTitle, seoDesc, eyebrow, title, subtitle, empty, image, children }) => {
  useSeo(seoTitle, seoDesc);
  const [videos, setVideos] = useState(null);
  useEffect(() => { api.get(`/videos?category=${category}`).then((r) => setVideos(r.data)).catch(() => setVideos([])); }, [category]);
  return (
    <>
      <FollowBar />
      <PageHero eyebrow={eyebrow} title={title} image={image} subtitle={subtitle} />
      <section className="container-x py-16" data-testid={`${category}-videos-section`}>
        {videos === null && <Loader2 className="animate-spin text-brand" />}
        {videos?.length === 0 && (
          <div className="card-dark flex items-center gap-4 p-8 text-mute" data-testid="gallery-empty"><Film className="text-brand" /> {empty}</div>
        )}
        <div className="grid items-start gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {videos?.map((v) => (
            <article key={v.id} className="card-dark overflow-hidden" data-testid={`gallery-video-${v.id}`}>
              <VideoPlayer v={v} />
              {(v.title || v.description) && <div className="p-5">{v.title && <h2 className="font-display text-lg font-bold">{v.title}</h2>}{v.description && <p className="mt-1 text-sm text-mute">{v.description}</p>}</div>}
            </article>
          ))}
        </div>
      </section>
      {children}
    </>
  );
};

export default function Gallery() {
  return (
    <VideoPage category="instructivo" seoTitle="Videos instructivos de suspensión" seoDesc="Videos instructivos sobre suspensión, dirección y frenos del Taller de Suspensiones La Gringa, Mérida."
      eyebrow="Galería" title="Videos instructivos de suspensión" image={IMG.garage}
      subtitle="Aprende cómo funciona la suspensión de tu auto, qué síntomas cuidar y cómo trabajamos en el taller."
      empty="Muy pronto subiremos videos instructivos."><PhotoGallery /></VideoPage>
  );
}
